import script from "./TutorialHelpBottomSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./TutorialHelpBottomSheet.vue?vue&type=script&setup=true&lang=ts"

import "./TutorialHelpBottomSheet.vue?vue&type=style&index=0&id=e8f5ff24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8f5ff24"]])

export default __exports__